import React from 'react';
import ReactDOM from 'react-dom';
import { Message } from 'oskari-ui';
import { ThemeProvider } from 'oskari-ui/util';
import { FeatureDataPluginHandler } from './FeatureDataPluginHandler';
import { FEATUREDATA_WFS_STATUS } from '../view/FeatureDataContainer';
import { MapModuleTextButton } from '../../../mapping/mapmodule/MapModuleTextButton';

/**
 * @class Oskari.mapframework.bundle.featuredata.plugin.FeaturedataPlugin
 * Provides WFS grid link on top of map
 */
Oskari.clazz.define('Oskari.mapframework.bundle.featuredata.plugin.FeaturedataPlugin',
/**
 * @method create called automatically on construction
 * @static
 * @param {Object} config
 *      JSON config with params needed to run the plugin
 */
function () {
  var me = this;
  me._clazz = 'Oskari.mapframework.bundle.featuredata.plugin.FeaturedataPlugin';
  me._defaultLocation = 'top right';
  me._index = 100;
  me._name = 'FeaturedataPlugin';
  me._mapStatusChanged = true;
}, {
  _startPluginImpl: function _startPluginImpl() {
    this.setElement(this._createControlElement());
    this.addToPluginContainer(this.getElement());
    this.refresh();
  },
  /**
   * @method _createControlElement
   * @private
   * Creates container for UI for feature data plugin
   */
  _createControlElement: function _createControlElement() {
    return jQuery('<div class="mapplugin featuredataplugin"></div>');
  },
  /**
   * Handle plugin UI and change it when desktop / mobile mode
   * @method  @public redrawUI
   * @param  {Boolean} mapInMobileMode is map in mobile mode
   * @param {Boolean} forced application has started and ui should be rendered with assets that are available
   */
  redrawUI: function redrawUI(mapInMobileMode, forced) {
    this.refresh();
  },
  /**
   * @method  @public mapStatusChanged map status changed
   * @param  {Boolean} changed is map status changed
   */
  mapStatusChanged: function mapStatusChanged() {
    var changed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this._mapStatusChanged = changed;
  },
  getMapStatusChanged: function getMapStatusChanged() {
    return this._mapStatusChanged;
  },
  /**
   * @method refresh
   * Updates the plugins interface (hides if no featuredata layer selected)
   */
  refresh: function refresh() {
    var _this = this;
    if (!this.handler) {
      this.handler = new FeatureDataPluginHandler(this.getMapModule());
      this.handler.addStateListener(function () {
        _this.renderButton();
      });
    }
    this.handler.updateStateAfterMapEvent();
  },
  renderButton: function renderButton() {
    var _this2 = this;
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var el = this.getElement();
    if (!el) {
      return;
    }
    var _this$handler$getStat = this.handler.getState(),
      flyoutOpen = _this$handler$getStat.flyoutOpen,
      layers = _this$handler$getStat.layers,
      loadingStatus = _this$handler$getStat.loadingStatus;
    this.toggleGFI(!flyoutOpen);
    var marginRight = '0';
    var marginLeft = '0';
    var position = this.getLocation();
    if (position.includes('right')) {
      marginRight = '10';
    } else if (position.includes('left')) {
      marginLeft = '10';
    }
    ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, {
      value: this.getMapModule().getMapTheme()
    }, /*#__PURE__*/React.createElement(MapModuleTextButton, {
      visible: (layers === null || layers === void 0 ? void 0 : layers.length) > 0,
      onClick: function onClick() {
        return _this2.handler.openFlyout();
      },
      active: flyoutOpen,
      loading: loadingStatus.loading,
      position: this.getLocation(),
      $marginRight: marginRight,
      $marginLeft: marginLeft,
      $marginTop: '10'
    }, /*#__PURE__*/React.createElement(Message, {
      messageKey: "title",
      bundleKey: "FeatureData"
    }))), el[0]);
  },
  toggleGFI: function toggleGFI(blnEnable) {
    var gfiReqBuilder = Oskari.requestBuilder('MapModulePlugin.GetFeatureInfoActivationRequest');
    // enable or disable gfi requests
    if (gfiReqBuilder) {
      this.getSandbox().request(this, gfiReqBuilder(blnEnable));
    }
  },
  /**
   * @method _hasFeaturedataLayers
   * @private
   * Check whether there are layers with featuredata present -> determine the control element's visibility
   */
  _hasFeaturedataLayers: function _hasFeaturedataLayers() {
    // see if there's any wfs layers, show element if so
    return this.getSandbox().findAllSelectedMapLayers().filter(function (layer) {
      return layer.isVisibleOnMap();
    }).some(function (layer) {
      return layer.hasFeatureData && layer.hasFeatureData();
    });
  },
  _createEventHandlers: function _createEventHandlers() {
    return {
      MapMoveStartEvent: function MapMoveStartEvent() {
        // reset our own bookkeeping for layer statuses on each map move since we
        // can't rely on OpenLayers telling us about each status change
        this.handler.updateLoadingStatus({}, false);
      },
      AfterMapMoveEvent: function AfterMapMoveEvent() {
        this.handler.updateStateAfterMapEvent();
      },
      AfterMapLayerAddEvent: function AfterMapLayerAddEvent(event) {
        if (event.getMapLayer().hasFeatureData()) {
          this.handler.updateStateAfterMapEvent();
        }
      },
      AfterMapLayerRemoveEvent: function AfterMapLayerRemoveEvent(event) {
        if (event.getMapLayer().hasFeatureData()) {
          this.handler.updateStateAfterMapEvent();
        }
      },
      MapLayerVisibilityChangedEvent: function MapLayerVisibilityChangedEvent() {
        this.handler.updateStateAfterMapEvent();
      },
      WFSFeaturesSelectedEvent: function WFSFeaturesSelectedEvent(event) {
        this.handler.updateSelectedFeatures(event.getMapLayer().getId(), event.getWfsFeatureIds());
      },
      WFSStatusChangedEvent: function WFSStatusChangedEvent(event) {
        if (event.getLayerId() === undefined) {
          return;
        }
        var _this$handler$getStat2 = this.handler.getState(),
          loadingStatus = _this$handler$getStat2.loadingStatus;
        if (event.getStatus() === event.status.loading) {
          loadingStatus['' + event.getLayerId()] = FEATUREDATA_WFS_STATUS.loading;
          this.renderButton(true);
        }
        if (event.getStatus() === event.status.complete) {
          delete loadingStatus['' + event.getLayerId()];
        }
        if (event.getStatus() === event.status.error) {
          if (loadingStatus.hasOwnProperty('' + event.getLayerId())) {
            loadingStatus['' + event.getLayerId()] = FEATUREDATA_WFS_STATUS.error;
          }
        }
        var layersStillLoading = !!Object.keys(loadingStatus).find(function (key) {
          return loadingStatus[key] && loadingStatus[key] === FEATUREDATA_WFS_STATUS.loading;
        });
        loadingStatus.loading = layersStillLoading;
        // wfs status changed -> also update features / columns etc.
        this.handler.updateLoadingStatus(loadingStatus, true);
      }
    };
  }
}, {
  extend: ['Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin'],
  /**
   * @property {String[]} protocol array of superclasses as {String}
   * @static
   */
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});